import request from '@/utils/request'

const getList = (data) => {
  const { bookName, authorName, author, page, limit, sort } = data
  let query = `page=${page + 1}&limit=${limit}&sortBy=${
    sort.field
  }&orderBy=${sort.type}`

  if(bookName) query += `&bookName=${encodeURI(bookName)}`
  if(authorName) query += `&authorName=${encodeURI(authorName)}`

  return request({
    url: `/api/request-books?${query}`,
    method: 'get'
  })
}

const download = () => {
  return request({
    url: `/api/request-books/download`,
    method: 'get',
    responseType: 'blob'
  })
}

export default {
  getList,
  download
}
